import { mapPartnerStatusFromApi } from "~/entity/Partners/lib/partnerStatus";
import { IPartner, IPartnerApi } from "~/entity/Partners/model/schema";

export const mapPartnerApiToView = (partner: IPartnerApi): IPartner => ({
  id: partner.id,
  name: partner.name,
  inn: partner.inn ?? "",
  country: partner.country ?? "",
  fo: partner.federalDistrict ?? "",
  region: partner.region ?? "",
  city: partner.city ?? "",
  locality: partner.locality ?? "",
  street: partner.street ?? "",
  house: partner.house ?? "",
  zipCode: partner.zipCode ?? "",
  address: partner.address ?? "",
  status: mapPartnerStatusFromApi(partner.status),
  createdAt: partner.createdAt,
  updatedAt: partner.updatedAt,
  author: partner.createdByName ?? "",
});

export const mapPartnersApiToView = (partners: IPartnerApi[]): IPartner[] =>
  partners.map(mapPartnerApiToView);
